import React from 'react';
import * as ROUTES from '../../../router/Routes';
import ContainerTemplate from '../../../widgets/template/Container';
import MonedasView from './MonedasView';

const MonedasModule = () => {
  return (
    <ContainerTemplate active={ROUTES.monedas} routes={[ROUTES.root]}>
      <MonedasView />
    </ContainerTemplate>
  );
};

export default MonedasModule;
